import React from 'react'
import { Redirect } from 'react-router-dom'
import { useMutation } from '@apollo/client'
import Layout from '../../Layout'
import Error from '../../Error'
import EditHeader from '../../Edit/Header'
import Form from '../Form'
import initialValues from './lib/initialValues'
import mutation from './lib/mutation'
import update from './lib/update'

export default () => {
  const [mutate, mutationProps] = useMutation(mutation, {
    update,
  })

  return (
    <Layout>
      <EditHeader>New user</EditHeader>

      <Form
        initialValues={initialValues}
        onSubmit={(data) => mutate({ variables: { data } })}
      />
      {mutationProps.error && <Error leftAligned />}
      {mutationProps.data && <Redirect to='/users' />}
    </Layout>
  )
}
